import './styles.css';
import { bootstrapInContainer, bootstrapStandalone, type BootConfig } from './bootstrap';

declare global {
  interface Window {
    APC_V3_BOOT?: Record<string, BootConfig>;
  }
}

async function bootstrapWordPressMounts(configMap: Record<string, BootConfig>): Promise<boolean> {
  const entries = Object.entries(configMap);
  if (!entries.length) {
    return false;
  }

  await Promise.all(
    entries.map(async ([containerId, config]) => {
      const container = document.getElementById(containerId);
      if (!container) {
        console.warn(`APC_V3_BOOT container not found: ${containerId}`);
        return;
      }

      await bootstrapInContainer(container, {
        ...config,
        context: 'wordpress',
        showHeader: typeof config.showHeader === 'boolean' ? config.showHeader : false
      });
    })
  );

  return true;
}

async function main(): Promise<void> {
  const hasWordPressMounts = await bootstrapWordPressMounts(window.APC_V3_BOOT || {});
  if (hasWordPressMounts) {
    return;
  }

  if (document.getElementById('apc-v3-host')) {
    await bootstrapStandalone();
  }
}

void main();
